/**
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the Commercial License found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _computeDataStep = _interopRequireDefault(require("./computeDataStep"));
var _useStickyRows = _interopRequireDefault(require("./useStickyRows"));
var _useGroupBy = _interopRequireDefault(require("./useGroupBy"));
var _default = function _default(props, computedProps, computedPropsRef) {
  Object.assign(computedProps, (0, _useStickyRows.default)(props, computedProps, computedPropsRef));
  Object.assign(computedProps, (0, _useGroupBy.default)(props, computedProps, computedPropsRef));
  return {
    computeDataStep: _computeDataStep.default
  };
};
exports.default = _default;